var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 13",
    style: {
      enableBackground: "new 0 0 15 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF625A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,11l-2.8-4.9L8.6,1.2c-0.5-0.9-1.8-0.9-2.3,0L3.5,6.1L0.7,11c-0.5,0.9,0.1,2,1.1,2h5.7h5.7 C14.2,13,14.8,11.9,14.3,11z M6.9,4.1c0.3-0.3,0.8-0.3,1.1,0c0.2,0.2,0.2,0.4,0.2,0.6L8.2,8.6c0,0.4-0.3,0.7-0.7,0.7 C7.1,9.3,6.8,9,6.8,8.6L6.7,4.7C6.7,4.5,6.8,4.3,6.9,4.1z M7.5,11.2c-0.5,0-0.8-0.4-0.8-0.8S7,9.5,7.5,9.5s0.8,0.4,0.8,0.8 S8,11.2,7.5,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.539c18d23caf6ad6eba73d60ad666df0.svg";
export { ForwardRef as ReactComponent };